import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WidgetService } from 'src/app/core/http/web/widget.service';
import { Router } from '@angular/router';
import { InsurancePassengersComponent } from './components/insurance-passengers/insurance-passengers.component';
import { DatepickerComponent } from '../inputs/datepicker/datepicker.component';
import { MenuComponent } from '../inputs/menu/menu.component';
import { saveDataSearchUtil } from 'src/app/core/services/utilities/saveDataSearchUtil.service';
import { HomeSegurosComponent } from 'src/app/modules/web/seguros/home-seguros/home-seguros.component';

@Component({
    selector: 'app-insurance',
    templateUrl: './insurance.component.html',
    styleUrls: ['./insurance.component.scss']
})
export class InsuranceComponent implements OnInit {
    public airports: any;
    @Input() public widgetData: any = null;

    @ViewChild('picker1') datePicker: DatepickerComponent;
    @ViewChild('picker2') datePicker2: DatepickerComponent;
    @ViewChild('sig') refEmail: ElementRef;
    @ViewChild('sig2') refEmail2: ElementRef;
    @ViewChild('pasajeros')
    public passengers: InsurancePassengersComponent;
    @ViewChild('pasajeros2')
    @ViewChild('appMenu') menuapp: MenuComponent;
    public passengers2: InsurancePassengersComponent;
    public submited: boolean;
    public form: FormGroup;
    public inicio: any = new Date((new Date).setDate((new Date).getDate() + 1));
    public loader: any = false;
    // productivo
    private urlSendData =  'https://colon.mundojoven.com/';
    // ppreproductivo
    // private urlSendData = 'http://dev2.mundojoven.com/0817mjb2cpro/';

    constructor(
        private formB: FormBuilder,
        private wtServ: WidgetService,
        private router: Router,
        private saveInfoServ: saveDataSearchUtil
    ) {
        this.form = this.formB.group({
            date: ['', [Validators.required]],
            fDestino: ['', [Validators.required]],
            fMail: ['', [Validators.required, Validators.email]],
            fPasajeros: ['', [Validators.required]],
            isInternational: ['true', []]
        });
        this.buildForm();
        this.getAirports();
    }

    ngOnInit() { }

    getAirports() {
        this.wtServ.getAirports().subscribe(
            data => {
                this.airports = data.data;
            }
        );
    }

    buildForm() {
        this.form.get('fDestino').valueChanges.subscribe(value => {
            if (value !== '') {
                this.saveInfoSearchFy('destino', value);
                if (document.documentElement.clientWidth < 992) {
                    this.datePicker2.openDatepicker();
                    this.menuapp.closeOnClick = true;
                } else {
                    this.datePicker.openDatepicker();
                    this.menuapp.closeOnClick = true;
                }
            }
        });

        this.form.get('date').valueChanges.subscribe(value => {
            // console.log("DATE cambió: ", value);

            if (value.length === 2) {
                this.saveInfoSearchFy('fecha_ida', value[0]);
                this.saveInfoSearchFy('fecha_vuelta', value[1]);
                if (document.documentElement.clientWidth < 992) {
                    this.refEmail2.nativeElement.focus();
                } else {
                    this.refEmail.nativeElement.focus();
                }
            }
        });

        this.form.get('fMail').valueChanges.subscribe(value => {
            if (this.isValidEmail(value)) {
                if (document.documentElement.clientWidth < 992) {
                    setTimeout(() => {
                        this.passengers2.menuModal.openMenu();
                    }, 1000);
                } else {
                    this.passengers.menuModal.openMenu();
                }
            }
        });
        // console.log('Form: ', this.form);
    }

    isValidEmail(email) {
        // tslint:disable-next-line: max-line-length
        const re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    updateForm(data) {
        // console.log('DATA:', data);
        this.form.controls.fPasajeros.setValue(data);
    }

    saveInfoSearchFy(key, value) {
        this.saveInfoServ.saveData('Widget seguros', key, value);
    }

    enviar() {
        this.submited = true;
        const data = this.form.value;
        const data2 = JSON.parse(JSON.stringify(this.form.value));
        if (this.form.invalid || this.form.get('date').value.length < 2) {

            console.log('Seguros-enviar --> ', data);
            console.log('form.value --> ', this.form.value);

            // console.log("MALDITA SEA: ", this.form.value);


            setTimeout(() => {
                this.form.get('date').setValue(data2.date);
            }, 2000);
            return;
        }
        console.log('Seguros-enviar --> ', data);
        console.log('form.value --> ', this.form.value);
        this.saveInfoSearchFy('correo', data.fMail);
        this.saveInfoSearchFy('pasengers', JSON.stringify(data.fPasajeros));
        const URL = this.buildURL(data);

        // console.log("Antes de enviar: ", data);
        // console.log("despues de enviar: ", data);
        console.log('  URL --> ', URL);
        console.log('  URL.dateFrom --> ', URL.dateFrom);
        console.log('  URL.dateTo --> ', URL.dateTo);
        console.log('  URL.dateTo --> ', URL.dateTo);
        if ( URL.destino === 'Nacional') {
            URL.destino = 1;
        } else {
            URL.destino = 2;
        }

        console.log('  URL.destino --> ', URL.destino);

        // tslint:disable-next-line: max-line-length
        const dataUrl = `${this.urlSendData}seguros.html#/voucher/passengersISIC/0/passengersM45/${URL.passengerNormal}/passengersMAY45/0/passengersMAY70/0/tipoViaje/${URL.destino}/dateFrom/${URL.dateFrom}/dateTo/${URL.dateTo}/utm_source/utm_medium/utm_campaign/hb_usr/landing`;
        // console.log('dataUrl -->', dataUrl);

        this.router.navigate(['/redireccion']);
        setTimeout(() => {
            window.open(dataUrl, '_self');
        }, 4000);



    }

    buildURL(data) {
        // MundoJoven 1
        // let urlBase = 'https://colon.mundojoven.com/seguros.html#/voucher/';

        // let passengersISIC, passengersM45, dateFrom, dateTo;

        // passengersISIC = 0;
        // passengersM45 = data.fPasajeros.numPassangers;
        // dateFrom = data.date[0].split('-').join('/');
        // dateTo = data.date[1].split('-').join('/');

        // urlBase = urlBase.concat('passengersISIC/', passengersISIC);
        // urlBase = urlBase.concat('/passengersM45/', passengersM45);
        // urlBase = urlBase.concat('/passengersMAY45/0/passengersMAY70/0/tipoViaje/1')
        // urlBase = urlBase.concat('/dateFrom/', dateFrom);
        // urlBase = urlBase.concat('/dateTo/', dateTo);
        // urlBase = urlBase.concat('/utm_source//utm_medium//utm_campaign//hb_usr/bW90aGVyQG1haWxpbmF0b3IuY29t');
        // return urlBase;

        // MundoJoven 2.0

        let passengersISIC, passengersM45, dateFrom, dateTo, isInternational, destino;

        passengersISIC = 0;
        passengersM45 = data.fPasajeros.numPassangers;
        dateFrom = data.date[0].split('-').join('/');
        dateTo = data.date[1].split('-').join('/');
        destino = data.fDestino;

        const urlBase = {
            dateFrom: dateFrom,
            dateTo: dateTo,
            passengerIsic: passengersISIC,
            passengerNormal: passengersM45,
            maxAgeIsic: 30,
            maxAgeNormal: 50,
            destino: destino,
            isInternational: data.isInternational,
            isIsic: JSON.stringify(passengersISIC.length > 0)
        };

        return urlBase;
    }

    enviaDatos() {
        console.log('Aqui envia datos');
    }


}
